<template>
  <div>

<!-- eventually trhis needs to be unified with the snow project component - MJ -->
<!-- left for now - since parent components handle update emits differently (and that's a larger change) -->

    <wc-data-box
      v-if='estimate'
      title='Driveway Rating'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='edit'
      :loading='isLoading'
    >
      <v-card-text class='text-center'>
        <h1 class='display-1 font-weight-light info--text'>{{ ratingDisplay.rating | dec }}</h1>
        <h2 class='mt-2'>{{ ratingDisplay.description }}</h2>
      </v-card-text>
      <wc-ratings :selected_obj='estimate.estimate_detail.driveway_rating_obj'></wc-ratings>
    </wc-data-box>
    <wc-dialog
      :showDialog='showDialog'
      title='Change Rating'
      :icon='icon'
      :iconColor='iconColor'
      width='300'
      @cancel='showDialog = false'
      @save='updateRating'
    >
      <v-select
        v-model='estimateCopy.estimate_detail.driveway_rating'
        label='Select a rating'
        :items='ratings'
        item-text='description'
        item-value='id'
      >
        <template v-slot:item='{ item }'>
          {{ "$" + item.base_price + " - " + item.description }}
        </template>
      </v-select>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import settingsAPI from '@/modules/settings/api/settings'
// import estimatesAPI from '@/modules/estimates/api/estimates'

export default {
  name: 'estimate-driveway-rating',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isSaving: false,
    showDialog: false,
    estimateCopy: {estimate_detail: {}},
    ratings: [],
    icon: 'mdi-home-outline',
    iconColor: 'brown'
  }),
  mounted () {
    this.getRatings()
  },
  computed: {
    ratingDisplay () {
      if (this.estimate && this.estimate.estimate_detail) {
        if (this.estimate.estimate_detail.driveway_rating && this.ratings.length) {
          return this.ratings.find(r => r.id === this.estimate.estimate_detail.driveway_rating)
        }
      }
      return { rating: null, description: '' }
    }
  },
  methods: {
    edit () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showDialog = true
    },
    async getRatings () {
      this.isLoading = true
      let tmp = await settingsAPI.getDrivewayRatings()
      this.ratings = _.orderBy(tmp, 'rating')
      this.isLoading = false
    },
    async updateRating () {
      this.isSaving = true
      this.$emit('updateDetail', this.estimateCopy.estimate_detail)
      // this.$emit('update', this.estimateCopy)
      this.isSaving = false
      this.showDialog = false
    }
  }
}
</script>
